import React, { useState } from 'react';
import cx from 'classnames';
import {connectRefinementList} from "react-instantsearch-dom";

const Refinement = (props) => {
    const [extended, setExtended] = useState(false);
    const {
        title,
        items,
        currentRefinement,
        refine,
        showMore,
        limit,
        isFromSearch,
        searchForItems,
        createURL
    } = props;

    if (currentRefinement.length <= 0 && items.length <= 0) {
        return null;
    }

    return (
        <>
            <h4>{title}</h4>
            <div className="ais-RefinementList">
                <ul className="ais-RefinementList-list">
                    {items.map(
                        (item, i) =>
                            (i < limit || extended) && (
                                <li
                                    key={item.label}
                                    className={cx("ais-RefinementList-item", {
                                        "ais-RefinementList-item--selected": item.isRefined
                                    })}
                                >
                                    <label className="ais-RefinementList-label">
                                        <input
                                            className="ais-RefinementList-checkbox"
                                            type="checkbox"
                                            value={item.label}
                                            checked={item.isRefined}
                                            onChange={event => refine(item.value)}
                                        />
                                        <span className="ais-RefinementList-labelText">{item.label}</span>
                                        <span className="ais-RefinementList-count">{item.count}</span>
                                    </label>
                                </li>
                            )
                    )}
                </ul>
                {(items.length > limit && showMore) && (
                    <button
                        onClick={() => {
                            setExtended(!extended);
                        }}
                        className="ais-RefinementList-showMore"
                    >
                        {extended ? "Voir moins" : "Voir plus"}
                    </button>
                )}
            </div>
        </>
    );
};

export default connectRefinementList(Refinement);
